import { useMutation } from 'Data/Api.js'
import { useDataSubmit, useDataValue } from 'Simple/Data.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'

import mutation from './mutation.graphql.js'

export default function useListItemDataOnSubmit(props) {
  let image_id = useDataValue({
    viewPath: props.viewPath,
    context: 'patient_image',
    path: '_id',
  })
  let location_id = useDataValue({
    context: 'global',
    path: 'current_location._id',
    viewPath: props.viewPath,
  })

  let submit = useDataSubmit({
    context: 'patient_image',
    viewPath: props.viewPath,
  })

  let [, executeMutation] = useMutation(mutation)
  let [, notify] = useNotifications()

  return async function onSubmit({ args, value, change }) {
    if (value.properties) {
      await submit({
        type: 'open_apps_launcher_properties',
        launcher: value,
      })

      return
    }

    let mutationResponse = await executeMutation({
      id: value.id,
      resource_id: image_id,
      location_id,
    })
    if (mutationResponse.error) {
      return notify(notifyError(`There was a problem launching the app.`))
    }

    if (!mutationResponse.data.apps_launchers_resolve.ok) {
      return notify(
        notifyError(mutationResponse.data.apps_launchers_resolve.message)
      )
    }

    switch (value.type) {
      case 'URL_HTTP':
      case 'URL_STATIC': {
        switch (value.displayFormat) {
          case 'MODAL_FULLSCREEN': {
            await submit({
              type: 'open_apps_launcher_url_modal_fullscreen',
              launcher: {
                ...value,
                url: mutationResponse.data.apps_launchers_resolve.url,
              },
            })
            break
          }

          case 'NEW_WINDOW':
          default: {
            window.open(mutationResponse.data.apps_launchers_resolve.url)
            break
          }
        }
        break
      }

      default: {
        break
      }
    }

    if (mutationResponse.data.apps_launchers_resolve.message) {
      return notify(
        notifySuccess(mutationResponse.data.apps_launchers_resolve.message)
      )
    }
  }
}
